import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Fragment } from 'react/jsx-runtime';

interface LoaderProps {
  row?: number;
  column?: number;
  noTopBorder?: boolean;
}

export const TableSkeletonLoader = ({
  row = 0,
  column = 0,
  noTopBorder,
}: LoaderProps) => {
  const numberToArray = (num: number) =>
    Array.from({ length: num }, (_, i) => i);
  const countColumn = numberToArray(column);
  const countRow = numberToArray(row);
  return (
    <>
      <Wrapper>
        <HeaderWrapper>
          {!noTopBorder && <Skeleton height={1} />}
          <TableWrapper column={column} className="headerTableWrapper">
            {countColumn.map((_, colIndex) => (
              <Skeleton key={colIndex} />
            ))}
          </TableWrapper>
          <Skeleton height={1} />
        </HeaderWrapper>

        <TableWrapper column={column}>
          {countRow.map((_, rowIndex) => (
            <Fragment key={rowIndex}>
              {countColumn.map((_, colIndex) => (
                <Skeleton key={colIndex} />
              ))}
            </Fragment>
          ))}
        </TableWrapper>
      </Wrapper>
    </>
  );
};

const HeaderWrapper = styled.div`
  .react-loading-skeleton {
    --base-color: ${p => p.theme.skeletonBaseColor};
    --highlight-color: ${p => p.theme.skeletonHighlightColor};
    line-height: 2;
  }
  .headerTableWrapper {
    gap: 25px 15px;
    padding: 11px 25px;
  }
  & > span {
    display: flex;
    line-height: 0;
  }
`;
const Wrapper = styled.div`
  width: 100%;
  padding: 0;
  height: 100%;
`;

interface TableWrapperProps {
  column?: number;
}

export const TableWrapper = styled.div<TableWrapperProps>`
  @media (max-width: 1200px) {
    .table-content :last-child {
      display: none !important;
    }
    .heading :last-child {
      display: none !important;
    }
  }
  .react-loading-skeleton {
    --base-color: ${p => p.theme.skeletonBaseColor};
    --highlight-color: ${p => p.theme.skeletonHighlightColor};
    line-height: 1.5;
  }
  display: grid;
  grid-template-columns: repeat(${p => p.column}, 1fr);
  padding: 20px 25px;
  gap: 39px 15px;
  .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 25px;
  }
  .table-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 50px;
    width: 100%;
    margin-top: 10px;
  }
`;
